import React, { useEffect, useState } from 'react'
import IndiaboatsFeedWidget from './IndiaboatsFeedWidget'
import { PawPrint } from 'lucide-react';

const API_BASE_URL = "";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [subscribing, setSubscribing] = useState(false);

  const handleNewsletterSubmit = async (event) => {
    event.preventDefault();

    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
      alert("Please enter your email");
      return;
    }

    try {
      setSubscribing(true);

      const response = await fetch(`${API_BASE_URL}/api/newsletter`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: trimmedEmail }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || "Failed to subscribe");
      }

      alert(result.message || "Subscribed successfully");
      setEmail("");
    } catch (error) {
      console.error("Newsletter subscribe error:", error);
      alert(error.message || "Failed to subscribe");
    } finally {
      setSubscribing(false);
    }
  };

   useEffect(() => {
    const existingScript = document.querySelector(
      'script[src="https://d2mpatx37cqexb.cloudfront.net/delightchat-whatsapp-widget/embeds/embed.min.js"]'
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src =
        "https://d2mpatx37cqexb.cloudfront.net/delightchat-whatsapp-widget/embeds/embed.min.js";
      script.async = true;

      script.onload = () => {
        if (window._waEmbed) {
          window._waEmbed({
            btnColor: "#16BE45",
            ctaText: "WhatsApp Us",
            cornerRadius: 40,
            marginBottom: 20,
            marginLeft: 20,
            marginRight: 20,
            btnPosition: "right",
            whatsAppNumber: "918591983301",
            welcomeMessage: "Hi\nI want an awesome sailing experience",
            zIndex: 999999,
            btnColorScheme: "light",
          });
        }
      };

      document.body.appendChild(script);
    }

  }, []);

  return (
    <>
    <footer className="footer-wrapper footer-layout1">
  <div className="widget-area">
    <div className="container">
      <div className="newsletter-area">
        <div className="newsletter-top">
          <div className="row gy-4 align-items-center">
            <div className="col-lg-5">
              <h2 className="newsletter-title text-capitalize mb-0">
                get updated the latest newsletter
              </h2>
            </div>
            <div className="col-lg-7">
              <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
                <input
                  className="form-control"
                  type="email"
                  placeholder="Enter Email"
                  required
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  disabled={subscribing}
                />
                <button type="submit" className="th-btn style3" disabled={subscribing}>
                  {subscribing ? "Subscribing..." : "Subscribe Now"}
                  <img src="assets/img/icon/plane.svg" alt="" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-between">
        <div className="col-md-6 col-xl-3">
          <div className="widget footer-widget">
            <div className="th-widget-about">
              <div className="about-logo">
                <a href="index.html">
                  <img src="/assets/img/ib_red_logo.png" alt="logo" />
                </a>
              </div>
              <p className="about-text">
                Visiting sightseeing destinations is a memorable part of the
                journey . The fun is multiplied when people can go for yacht
                sailing or boating into the deep waters along these coasts. We
                make it possible for people to fulfil their desires by providing
                information about different yacht hire services and various
                water related activities , plans can be done for the entire
                family or for friends or honeymooning couples and everybody can
                find something that suits his or her taste. We at India Boats
                have brought together a comprehensive profile to check out
                before embarking on one of your favourite and memorable
                vacations, making it a simple and a rewarding process.
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-xl-auto">
          <div className="widget widget_nav_menu footer-widget">
            <h3 className="widget_title">Quick Links</h3>
            <div className="menu-all-pages-container">
              <ul className="menu">
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/about">About us</a>
                </li>
                <li>
                  <a href="/privacy">Privacy Policy</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://indiaboats.in/Vendorcp/index.aspx"
                  >
                    Partner Login
                  </a>
                </li>
                <li>
                  <a href="/terms">Terms of use</a>
                </li>
                <li>
                  <a href="/refund">Refund Policy</a>
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://indiaboats.in/Affiliate/index.aspx"
                  >
                    Affiliate Login
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-xl-auto">
          <div className="widget footer-widget">
            <h3 className="widget_title">Address</h3>
            <div className="th-widget-contact">
              <div className="info-box_text">
                <div className="icon">
                  <img src="assets/img/icon/phone.svg" alt="img" />
                </div>
                <div className="details">
                  <p>
                    <a href="tel:+91 8591993301" className="info-box_link">
                      +91 8591993301
                    </a>
                  </p>
                  <p>
                    <a href="tel:+91 9004013301" className="info-box_link">
                      +91 9004013301
                    </a>
                  </p>
                  <p>
                    <a href="tel:+91 8591983301" className="info-box_link">
                      +91 8591983301
                    </a>
                  </p>
                  <p>
                    <a href="tel:+022 66958111" className="info-box_link">
                      {" "}
                      &nbsp; 022 66958111
                    </a>
                  </p>
                </div>
              </div>
              <div className="info-box_text">
                <div className="icon">
                  <img src="assets/img/icon/envelope.svg" alt="img" />
                </div>
                <div className="details">
                  <p>
                    <a
                      href="mailto:customercare@indiaboats.in"
                      className="info-box_link"
                    >
                      customercare@indiaboats.in
                    </a>
                  </p>
                </div>
              </div>
              <div className="info-box_text">
                <div className="icon">
                  <img src="assets/img/icon/location-dot.svg" alt="img" />
                </div>
                <div className="details">
                  <p>
                    803, Hubtown Viva, Western Express Highway, Jogeshwari East,
                    Mumbai - 400060, INDIA
                  </p>
                </div>

                
              </div>
              <div className="pet_friendly">
            <div className='paw_icon icon'><PawPrint size={22} color="#38bdf8" /></div>
            <div className='paw_text'>Pet Friendly</div>
          </div>
            </div>
          </div>
        </div>
<div className="col-md-6 col-xl-auto">
          <div className="widget footer-widget" id='widget_footer'>
           <div style={{ marginTop: "30px" }}>
        <IndiaboatsFeedWidget />
      </div>
            <h3 className="widget_title" id='social_media_title'>Social Media</h3>
            <div className="th-social">
              <a href="https://www.facebook.com/indiaboats.in/?fref=ts">
                <i className="fab fa-facebook-f" />
              </a>
              <a href="https://x.com/india_boats">
                <i className="fab fa-twitter" />
              </a>
              <a href="https://www.linkedin.com/in/india-boats-866220114/?originalSubdomain=in">
                <i className="fab fa-linkedin-in" />
              </a>
              <a href="https://www.youtube.com/channel/UC9sFJ9TzZTm9OupLqxd02wA">
                <i className="fab fa-youtube" />
              </a>
              <a href="https://instagram.com/">
                <i className="fab fa-instagram" />
              </a>
            </div>
          </div>

          
        </div>
      </div>
    </div>
  </div>
  <div className="copyright-wrap">
    <div className="container">
      <div className="row justify-content-between align-items-center">
        <div className="col-md-6">
          <p className="copyright-text">
            Copyright 2026 <a href="home-travel.html">India Boats</a>. All
            Rights Reserved.
          </p>
        </div>
        <div className="col-md-6 text-end d-none d-md-block">
          {/* <div class="footer-card">
          <span class="title">We Accept</span>
          <img src="assets/img/shape/cards.png" alt="" />
        </div> */}
        </div>
      </div>
    </div>
  </div>
</footer>
<div className="scroll-top">
  <svg
    className="progress-circle svg-content"
    width="100%"
    height="100%"
    viewBox="-1 -1 102 102"
  >
    <path
      d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
      style={{
        transition: "stroke-dashoffset 10ms linear 0s",
        strokeDasharray: "307.919, 307.919",
        strokeDashoffset: "307.919"
      }}
    />
  </svg>
</div>

    
    </>
  )
}